import { render } from "./DynamicQuickPost.vue.js?vue&type=template&id=77b368b1!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicQuickPost.vue?vue&type=template&id=77b368b1"
import script from "./DynamicQuickPost.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicQuickPost.vue?vue&type=script&lang=js"
export * from "./DynamicQuickPost.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicQuickPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/quick-post/DynamicQuickPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77b368b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77b368b1', __exports__)) {
    api.reload('77b368b1', __exports__)
  }
  
  module.hot.accept("./DynamicQuickPost.vue.js?vue&type=template&id=77b368b1!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicQuickPost.vue?vue&type=template&id=77b368b1", () => {
    api.rerender('77b368b1', render)
  })

}


export default __exports__